module.exports = __webpack_public_path__ + "static/media/Bullet_350.34778a2e.jpg";